<template>
  <b-overlay
    id="overlay-background"
    :show="loader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <div v-if="((farPayCallBackResponse && farPayCallBackResponse === 'success') && saveTransactionStatus === 200) && ((!tokenExpired && invoiceObject !== null))">
      <Header />
      <b-row>
        <b-col
          md="6"
          lg="4"
          offset-lg="4"
          offset-md="3"
        >
          <b-card
            no-body
            class="business-card"
          >
            <b-card-header class="pb-1">
              <b-card-title>{{ invoiceObject.invoice_bc_id }}</b-card-title>
            </b-card-header>

            <b-card-body>
              <b-card-text>{{ $t('DEBTIA_INSTALLMENTPLAN_FULLPAYMENT_END_MSG') }} {{ formatCurrency(invoiceObject.total, defaultCurrency) }}</b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="(farPayCallBackResponse && farPayCallBackResponse === 'failure') && saveTransactionStatus !== 200">
      <Header />
      <b-row>
        <b-col
          md="6"
          lg="4"
          offset-lg="4"
          offset-md="3"
        >
          <b-card
            class="text-center"
            footer-class="text-muted"
          >
            <div class="mb-1">
              {{ 'There has occured a problem in your payment/card details. Please try again.' }}
            </div>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              @click="invokeFarPay(invoiceObject.external_doc_no)"
            >
              {{ 'Try Again' }}
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="tokenExpired">
      <Header />
      <b-row>
        <b-col
          md="6"
          lg="4"
          offset-lg="4"
          offset-md="3"
        >
          <b-card
            class="text-center"
            footer-class="text-muted"
          >
            {{ $t('TOKEN_EXPIRED_MSG') }}
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="(!tokenExpired && invoiceObject === null) || saveTransactionStatus === 404">
      <Header />
      <b-row>
        <b-col
          md="6"
          lg="4"
          offset-lg="4"
          offset-md="3"
        >
          <b-card
            class="text-center"
            footer-class="text-muted"
          >
            {{ 'Invoice not found.' }}
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="(!tokenExpired && (invoiceObject && invoiceObject.paid === 0)) && saveTransactionStatusLoaded">
      <Header />
      <div class="container">
        <b-row>
          <b-col
            md="6"
            lg="4"
            offset-lg="4"
            offset-md="3"
            xs="12"
          >
            <b-card
              :title="$t('DEBTIA_INVOICE_ID') + ': ' + invoiceObject.invoice_bc_id"
              class="text-center"
              footer-class="text-muted"
            >
              <div id="my-container">
                <!-- Our triggering (target) element -->
                <b-button
                  id="popover-reactive-1"
                  ref="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="details-button"
                  variant="outline-primary"
                >
                  <!-- {{ $t('DEBTIA_PENDING_DEBT_TEXT') }} : {{ new Intl.NumberFormat('de-DE').format(remainingAmount) }} kr. -->
                  {{ $t('DEBTIA_PENDING_AMOUNT_TEXT') }} : {{ formatCurrency(invoiceObject.total, defaultCurrency) }}
                </b-button>

              <!-- Our popover title and content render container -->
              <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
              <!-- We specify the same container as the trigger button, so that popover is close to button -->
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            md="6"
            lg="6"
            offset-lg="3"
            offset-md="3"
            xs="12"
          >

            <b-card
              v-if="paymentmethodResponse !== 1"
              no-body
              class="business-card ml-4 mr-4"
            >
              <b-card-body>
                <div id="my-container">

                  <b-row>
                    <b-col
                      cols="12"
                      class="mb-2 text-center"
                    >
                      <h5 class="mb-0">
                        {{ 'Please click on the button to pay the amount.' }}
                      </h5>
                    <!--<small class="text-muted">
              {{ $t('message.DESC_PAYMENT_METHOD') }}
            </small>-->
                    </b-col>
                    <b-col
                      lg="8"
                      md="8"
                      sm="8"
                      offset-lg="2"
                      offset-md="2"
                      offset-sm="2"
                    >
                      <div>
                        <!-- large -->
                        <b-button-group
                          size="lg"
                        >
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            @click="invokeFarPay(invoiceObject.external_doc_no)"
                          >
                            {{ 'Pay the amount' }}
                          </b-button>
                        </b-button-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    <!-- <div
      v-if="spinnerstay"
      id="spinner-div"
    >
      <b-spinner
        key="success"
        variant="success"
        class="mr-1 custom-spinner-style"
        type="grow"
      />
    </div> -->
    </div>
    <div v-else>
      <Header />
      <div class="container">
        <b-row>
          <b-col
            md="6"
            lg="4"
            offset-lg="4"
            offset-md="3"
            xs="12"
          >
            <b-card
              title="Loading..."
              class="text-center"
              footer-class="text-muted"
            >
              <div id="my-container">
                <!-- Our triggering (target) element -->
                <b-button
                  id="popover-reactive-1"
                  ref="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="details-button"
                  variant="outline-primary"
                >
                  <!-- {{ $t('DEBTIA_PENDING_DEBT_TEXT') }} : {{ new Intl.NumberFormat('de-DE').format(remainingAmount) }} kr. -->
                  Please wait while the data is being loaded.
                </b-button>

              <!-- Our popover title and content render container -->
              <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
              <!-- We specify the same container as the trigger button, so that popover is close to button -->
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCardHeader,
  BCard,
  BRow,
  BCol,
  BButton,
  BCardTitle,
  BCardBody,
  BCardText,
  BButtonGroup,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import axios from 'axios'
import axiosIns from '../libs/axios'
import Header from './Header.vue'
// import constants from '../app-configs/constants'

export default {
  components: {
    BCardHeader,
    BCard,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardBody,
    BCardText,
    Header,
    BButtonGroup,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      tokenExpired: false,
      spinnerstay: true,
      paymentmethodResponse: 0,
      defaultCurrency: localStorage.getItem('defaultCurrency') || 'DKK',
      farPayCallBackResponse: null,
      saveTransactionStatus: 0,
      saveTransactionStatusLoaded: true,
      // INVOICE-DATA
      invoiceObject: {},
    }
  },
  created() {
    // this.tokenExpired = true
    this.loader = true
    let token = window.location.href.split('/')
    token = token.pop()
    let urlToken = null
    if (token.includes('?')) {
      const fullResult = token.split('?')
      // eslint-disable-next-line prefer-destructuring
      urlToken = fullResult[0]
      // console.log('this payemnts methods ', this.paymentmethod)
      const result = fullResult.pop()
      this.farPayCallBackResponse = result.includes('success') ? 'success' : 'failure'
      if (this.farPayCallBackResponse === 'success') this.saveTransaction(urlToken)
    } else {
      urlToken = token
    }
    axiosIns.get(`invoice-system/payment/${urlToken}`).then(response => {
      if (response.status) {
        this.invoiceObject = response.data.data.data
        this.tokenExpired = response.data.data.expired
        this.loader = false
      }
    }).catch(error => {
      console.log(error)
      this.tokenExpired = true
      this.loader = false
    })
  },
  methods: {
    async invokeFarPay(doc) {
      // console.log('this.paymentmethod ', this.paymentmethod)
      this.fetchingFarPayLoader = true
      const url = '/farpay/order/pay-invoice'
      const data = {
        external_doc_no: doc,
      }
      await axiosIns.post(url, data).then(response => {
        if (response.status === 200) {
          // console.log(' response.data.data.response ', response.data.data.response)
          // console.log('far pay response is ', response.data.data.response)
          localStorage.setItem('farPayUrl', response.data.data.response.UserInputUrl)
          window.location.href = response.data.data.response.UserInputUrl
          this.fetchingFarPayLoader = false
        }
      })
    },
    async saveTransaction(token) {
      this.saveTransactionStatusLoaded = false
      await axiosIns.post('/farpay/order/invoice-transaction', {
        external_doc_no: token,
      }).then(() => {
        this.saveTransactionStatus = 200
        this.saveTransactionStatusLoaded = true
      }).catch(() => {
        this.saveTransactionStatus = 404
      })
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';

  .custom {
    background: $primary;
  }
  .right-values{
    float: right;
  }
  @media only screen and (max-width: 767px){
    #spinner-div{
      height: 80%;
    }
  }
  @media only screen and (min-width: 767px){
    #spinner-div{
      height: 50%;
    }
  }
  #spinner-div{
    background-color: #f1efef;
    width: 100%;
    position: absolute;
    border-radius: 10px;
    z-index: 1;
    opacity: 0.7;
  }

  .custom-spinner-style{
    margin-left: 50%;
    margin-top: 10%;
  }
  .vue-form-wizard .wizard-nav-pills {
    display: flex;
    justify-content: center;
  }

  .btn-group.btn-group-lg{
    display: flex !important;
    justify-content: center;
  }

  .popover-body{
    padding: 12px 5px !important
  }

  .alert-div{
    padding: 10px;
    border: 1px solid #ff6e6e;
    border-radius: 6px;
    background-color: #ffe7e7;
    color: #ff5252;
  }

  .details-button {
    cursor: default !important;
  }

  @media only screen and (max-width: 767px){
    .btn-group-lg > .btn{
      font-size: 0.75rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
</style>
